import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var TestPipe = (function () {
    function TestPipe() {
    }
    TestPipe.prototype.transform = function (input, pattern, flag) {
        if (!isString(input) || !pattern) {
            return input;
        }
        var regexp = pattern instanceof RegExp ? pattern : new RegExp(pattern, flag);
        return regexp.test(input);
    };
    return TestPipe;
}());
export { TestPipe };
TestPipe.decorators = [
    { type: Pipe, args: [{
                name: 'test'
            },] },
];
/** @nocollapse */
TestPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=test.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/test.pipe.js
// module id = 292
// module chunks = 103